import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

const Iletisim: React.FC = () => {
  const [formSent, setFormSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);

    fetch('https://getform.io/f/bvryopnb', {
      method: 'POST',
      body: formData,
    })
      .then(response => {
        if (response.ok) {
          setFormSent(true);
          setTimeout(() => {
            setFormSent(false);
            navigate('/tesekkur');
          }, 2000);
          (e.target as HTMLFormElement).reset();
        } else {
          alert('Mesaj gönderilirken bir hata oluştu.');
        }
      })
      .catch(() => {
        alert('Mesaj gönderilirken bir hata oluştu.');
      });
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero - Minimal */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>İletişim</h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Profesyonel çözümlerimiz hakkında bilgi almak için uzman ekibimizle iletişime geçin
          </p>
        </div>
      </section>

      {/* Feature Cards */}
      <section style={{ padding: '2rem 0', background: '#f8fafc' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: '0 1.5rem' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1rem',
          }}>
            {[
              {
                icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0066CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                ),
                title: 'Hızlı Yanıt',
                description: '24 saat içinde dönüş'
              },
              {
                icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0066CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2A19.72 19.72 0 013 5.18 2 2 0 015 3h3a2 2 0 012 1.72c.13 1.05.37 2.07.72 3.06a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006.6 6.6l1.27-1.27a2 2 0 012.11-.45c.99.35 2.01.59 3.06.72A2 2 0 0122 16.92z" />
                  </svg>
                ),
                title: '7/24 Destek',
                description: 'Her zaman yanınızdayız'
              },
              {
                icon: (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0066CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                ),
                title: 'Güvenilir',
                description: 'Profesyonel ekip'
              },
            ].map((feature, index) => (
              <div
                key={index}
                style={{
                  background: '#fff',
                  borderRadius: 10,
                  padding: '1rem 1.25rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.875rem',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                  border: '1px solid #e2e8f0',
                }}
              >
                <div style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: '#f0f9ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  {feature.icon}
                </div>
                <div>
                  <div style={{
                    fontSize: '0.9375rem',
                    fontWeight: 600,
                    color: '#1e293b',
                    marginBottom: '0.125rem',
                  }}>
                    {feature.title}
                  </div>
                  <div style={{
                    fontSize: '0.8125rem',
                    color: '#64748b',
                  }}>
                    {feature.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section style={{ padding: '2.5rem 0' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: '0 1.5rem' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1.5rem',
            alignItems: 'stretch',
          }}>
            {/* Left Card - Contact Info */}
            <div style={{
              background: '#fff',
              borderRadius: 16,
              overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.04)',
            }}>
              {/* Card Header */}
              <div style={{
                background: 'linear-gradient(135deg, #0066CC 0%, #0052a3 100%)',
                color: '#fff',
                padding: '1.25rem 1.5rem',
              }}>
                <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.25rem' }}>
                  İletişim Bilgileri
                </h2>
                <p style={{ fontSize: '0.8125rem', opacity: 0.85 }}>Bize ulaşın</p>
              </div>

              {/* Card Body */}
              <div style={{ padding: '1.25rem 1.5rem' }}>
                {/* Address */}
                <div style={{ display: 'flex', gap: '0.875rem', marginBottom: '1rem' }}>
                  <div style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0066CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ fontSize: '0.875rem', color: '#334155', lineHeight: 1.5 }}>
                      Güzeloluk Mah. 1830. Sk. Florya Sitesi No: 202/B, Muratpaşa/Antalya
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem', marginBottom: '0.875rem' }}>
                  <div style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0066CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 01-2.18 2A19.72 19.72 0 013 5.18 2 2 0 015 3h3a2 2 0 012 1.72c.13 1.05.37 2.07.72 3.06a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006.6 6.6l1.27-1.27a2 2 0 012.11-.45c.99.35 2.01.59 3.06.72A2 2 0 0122 16.92z" />
                    </svg>
                  </div>
                  <a href="tel:08505325989" style={{ color: '#0066CC', textDecoration: 'none', fontSize: '0.9375rem', fontWeight: 500 }}>
                    0850 532 59 89
                  </a>
                </div>

                {/* Email */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem', marginBottom: '1.25rem' }}>
                  <div style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0066CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="4" width="20" height="16" rx="2" />
                      <path d="M22 7l-10 7L2 7" />
                    </svg>
                  </div>
                  <a href="mailto:info@motopack.com.tr" style={{ color: '#0066CC', textDecoration: 'none', fontSize: '0.9375rem', fontWeight: 500 }}>
                    info@motopack.com.tr
                  </a>
                </div>

                {/* Divider */}
                <div style={{ height: 1, background: '#e2e8f0', margin: '1rem 0' }} />

                {/* Social */}
                <div>
                  <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '0.625rem', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Sosyal Medya
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    {[
                      { href: 'https://www.facebook.com/motopack.com.tr', icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
                      { href: 'https://www.instagram.com/motopack_tr/', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
                      { href: 'https://motopack.com.tr/', icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
                    ].map((social, i) => (
                      <a
                        key={i}
                        href={social.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          width: 36,
                          height: 36,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: '#f1f5f9',
                          borderRadius: 8,
                          color: '#64748b',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#0066CC';
                          e.currentTarget.style.color = '#fff';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#f1f5f9';
                          e.currentTarget.style.color = '#64748b';
                        }}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d={social.icon} />
                        </svg>
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* Map */}
              <div style={{ height: 180, borderTop: '1px solid #e2e8f0' }}>
                <iframe
                  src="https://www.google.com/maps?q=Güzeloluk+Mah.+1830.+Sk.+Florya+Sitesi+No:+202+Muratpaşa+Antalya&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen
                  loading="lazy"
                  title="Motopack Antalya Ofis Konumu"
                />
              </div>
            </div>

            {/* Right Card - Form */}
            <div style={{
              background: '#fff',
              borderRadius: 16,
              overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.04)',
            }}>
              {/* Card Header */}
              <div style={{
                background: 'linear-gradient(135deg, #0066CC 0%, #0052a3 100%)',
                color: '#fff',
                padding: '1.25rem 1.5rem',
              }}>
                <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '0.25rem' }}>
                  Mesaj Gönderin
                </h2>
                <p style={{ fontSize: '0.8125rem', opacity: 0.85 }}>Sorularınız için formu doldurun</p>
              </div>

              {/* Card Body - Form */}
              <div style={{ padding: '1.5rem' }}>
                <form onSubmit={handleSubmit}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                    {/* Name */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500, fontSize: '0.8125rem', color: '#334155' }}>
                        Ad Soyad *
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="Adınız"
                        style={{
                          width: '100%',
                          padding: '0.625rem 0.875rem',
                          borderRadius: 8,
                          border: '1px solid #e2e8f0',
                          fontSize: '0.875rem',
                          transition: 'border-color 0.2s, box-shadow 0.2s',
                          outline: 'none',
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = '#0066CC';
                          e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 102, 204, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = '#e2e8f0';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500, fontSize: '0.8125rem', color: '#334155' }}>
                        E-posta *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="ornek@email.com"
                        style={{
                          width: '100%',
                          padding: '0.625rem 0.875rem',
                          borderRadius: 8,
                          border: '1px solid #e2e8f0',
                          fontSize: '0.875rem',
                          transition: 'border-color 0.2s, box-shadow 0.2s',
                          outline: 'none',
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = '#0066CC';
                          e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 102, 204, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = '#e2e8f0';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500, fontSize: '0.8125rem', color: '#334155' }}>
                        Telefon
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="0 5XX XXX XX XX"
                        style={{
                          width: '100%',
                          padding: '0.625rem 0.875rem',
                          borderRadius: 8,
                          border: '1px solid #e2e8f0',
                          fontSize: '0.875rem',
                          transition: 'border-color 0.2s, box-shadow 0.2s',
                          outline: 'none',
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = '#0066CC';
                          e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 102, 204, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = '#e2e8f0';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      />
                    </div>

                    {/* Subject */}
                    <div>
                      <label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500, fontSize: '0.8125rem', color: '#334155' }}>
                        Konu
                      </label>
                      <select
                        name="subject"
                        style={{
                          width: '100%',
                          padding: '0.625rem 0.875rem',
                          borderRadius: 8,
                          border: '1px solid #e2e8f0',
                          fontSize: '0.875rem',
                          background: '#fff',
                          cursor: 'pointer',
                          outline: 'none',
                        }}
                      >
                        <option value="genel">Genel Soru</option>
                        <option value="hizmetal">Hizmet Alımı</option>
                        <option value="kuryeol">Kurye Olmak İstiyorum</option>
                        <option value="isbirligi">İş Birliği</option>
                      </select>
                    </div>
                  </div>

                  {/* Message */}
                  <div style={{ marginTop: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 500, fontSize: '0.8125rem', color: '#334155' }}>
                      Mesaj *
                    </label>
                    <textarea
                      name="message"
                      rows={4}
                      required
                      placeholder="Mesajınızı yazın..."
                      style={{
                        width: '100%',
                        padding: '0.625rem 0.875rem',
                        borderRadius: 8,
                        border: '1px solid #e2e8f0',
                        fontSize: '0.875rem',
                        resize: 'vertical',
                        transition: 'border-color 0.2s, box-shadow 0.2s',
                        outline: 'none',
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = '#0066CC';
                        e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 102, 204, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = '#e2e8f0';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    />
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    style={{
                      marginTop: '1.25rem',
                      width: '100%',
                      padding: '0.75rem 1.25rem',
                      background: 'linear-gradient(135deg, #0066CC 0%, #0052a3 100%)',
                      color: '#fff',
                      fontWeight: 600,
                      fontSize: '0.9375rem',
                      borderRadius: 8,
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 2px 4px rgba(0, 102, 204, 0.2)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-1px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 102, 204, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 102, 204, 0.2)';
                    }}
                  >
                    Mesajı Gönder
                  </button>

                  {formSent && (
                    <div style={{
                      marginTop: '1rem',
                      padding: '0.75rem',
                      background: '#dcfce7',
                      color: '#166534',
                      borderRadius: 8,
                      fontSize: '0.875rem',
                      textAlign: 'center',
                      fontWeight: 500,
                    }}>
                      ✓ Mesajınız başarıyla gönderildi!
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        padding: '2.5rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h2 style={{ fontSize: '1.375rem', fontWeight: 700, color: '#fff', marginBottom: '0.375rem' }}>
            Herhangi Bir Yardım İhtiyacınız Var mı?
          </h2>
          <p style={{ fontSize: '0.9375rem', color: 'rgba(255,255,255,0.9)', marginBottom: '1rem' }}>
            Merak ettiğiniz her konuda, şikayet ve önerilerinizle ilgili olarak bizimle iletişime geçebilirsiniz.
          </p>
          <a
            href="https://api.whatsapp.com/send/?phone=908505325989"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              background: '#25D366',
              color: '#fff',
              fontWeight: 600,
              fontSize: '0.9375rem',
              borderRadius: 8,
              textDecoration: 'none',
              boxShadow: '0 2px 8px rgba(37, 211, 102, 0.3)',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            WhatsApp ile Yazın
          </a>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          section > div > div {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Iletisim;
